import React,{useContext} from "react";
import Slider from "react-slick";
import { Container } from "react-bootstrap";
import { UserSvg, StarSvg } from "./HomeSvg";
import { LanguageContext } from "../context/LanguageContext";

var settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  centerPadding: "60px",
  responsive: [
    {
      breakpoint: 1024, // Screens smaller than 1024px
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        centerPadding: "40px",
      },
    },
    {
      breakpoint: 768, // Screens smaller than 768px
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        centerPadding: "20px",
      },
    },
    {
      breakpoint: 480, // Screens smaller than 480px
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerPadding: "10px",
      },
    },
  ],
};
const RimiligTestimonials = () => {
  const { translations } = useContext(LanguageContext);
  const Testimonials = translations.testimonials?.testimonialsGrid || [];
   
  return (
    <div className="padding_cmn rm_testimonials">
      <Container>
        <h6 className="rm_subheading text-center">
     {translations.testimonials?.subTitle}
        </h6>
        <h2 className="text-center subTitle"> {translations.testimonials?.title}</h2>
        <div className="slider_grid">
        <Slider {...settings}>
          {Testimonials.map((testimonial, index) => (
            <div className="rm-testimonial" key={index}>
              <div className="d-flex">
                {UserSvg} 
                <span className="ms-auto">
                  {Array.from({ length: 5 }, (_, i) => (
                    <span key={i}>
                  {    StarSvg}
                    </span>
                  ))}
                </span>
              </div>
              <h5>{testimonial.name}</h5>
              <p>{testimonial.review}</p>
            </div>
          ))}
        </Slider>
        </div>
      </Container>
    </div>
  );
};

export default RimiligTestimonials;
